import { ChapterHead, Reveal } from "./motion";
import { OFFER, IMAGES } from "./data";

export const Overview = () => (
  <section data-testid="chapter-overview" className="chapter-print-break mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
    <ChapterHead num="01" title="Executive Overview" sub="A letter to the leadership of Vision Oil Field Equipment LLC" />
    <div className="grid gap-14 lg:grid-cols-12">
      <Reveal className="lg:col-span-7">
        <p className="text-lg leading-relaxed text-ink3">
          Dear Mr. Hamouda, Mr. Maged, and the Vision team,
        </p>
        <p className="mt-6 text-base leading-relaxed text-ink4">
          Your operations span four countries, eleven engineered equipment lines and seven service
          streams — held together today by separate ledgers, spreadsheets and memory. This proposal
          consolidates all of it onto one integrated Odoo platform: manufacturing, rentals, field
          service, procurement and finance, with e-invoicing compliance for the UAE, Saudi Arabia
          and Egypt built in from day one.
        </p>
        <p className="mt-5 text-base leading-relaxed text-ink4">
          The engagement is fixed-scope and phased over 6–7 months — operations first, finance last —
          with a stage-gate at the end of every phase. And before you commit to Phase 1, you will see
          Odoo running on Vision's own entities, fleet and assets in a live environment that becomes
          your tenant from day one, not a throw-away demo.
        </p>
        <p className="mt-8 border-l-2 border-amber-500 pl-6 font-display text-xl font-semibold text-ink">
          Fewer surprises. Faster answers. Decisions grounded in live data rather than last month's
          reconstruction.
        </p>
        <div className="mt-10">
          <p className="font-display text-lg font-semibold text-ink">{OFFER.consultant}</p>
          <p className="text-sm text-ink5">{OFFER.consultantRole} · September 2026</p>
        </div>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-5">
        <div className="group relative overflow-hidden rounded-sm border border-line">
          <img
            src={IMAGES.pumps}
            alt="Offshore oil rig at sea"
            className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-x-0 bottom-0 bg-[#0b0f17]/85 px-6 py-4 backdrop-blur-md">
            <p className="font-mono2 text-[10px] tracking-[0.3em] text-amber-500 uppercase">The Mandate</p>
            <p className="mt-1 text-sm text-slate-300">
              Consolidate five-country operations. Automate compliance. Run manufacturing, rentals and
              field service on one platform.
            </p>
          </div>
        </div>
        <div className="mt-6 flex flex-wrap gap-2">
          {OFFER.footprint.map((c) => (
            <span
              key={c}
              className="rounded-full border border-line px-4 py-1.5 font-mono2 text-[10px] tracking-[0.2em] text-ink4 uppercase"
            >
              {c}
            </span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
